var map = {
	"./0/Kambi/SecondaryMenu.layout": [
		8017,
		3215,
		6277
	],
	"./0/Poker/SecondaryMenu.layout": [
		4131,
		3215,
		1886
	],
	"./0/Spectate/SecondaryMenu.layout": [
		33790,
		3215,
		7894
	],
	"./1/Kambi/SecondaryMenu.layout": [
		21623,
		6266
	],
	"./1/Poker/SecondaryMenu.layout": [
		83330,
		3215,
		5145
	],
	"./1/Spectate/SecondaryMenu.layout": [
		97680,
		3215,
		2593
	],
	"./31/Kambi/SecondaryMenu.layout": [
		38185,
		3215,
		837
	],
	"./31/Poker/SecondaryMenu.layout": [
		38342,
		3215,
		3272
	],
	"./31/Spectate/SecondaryMenu.layout": [
		78059,
		3215,
		5120
	],
	"./58/Spectate/SecondaryMenu.layout": [
		39885,
		3215,
		5021
	],
	"./75/Kambi/SecondaryMenu.layout": [
		66881,
		3215,
		7645
	],
	"./75/Spectate/SecondaryMenu.layout": [
		97550,
		3215,
		4208
	],
	"./76/Kambi/SecondaryMenu.layout": [
		81061,
		3215,
		6288
	],
	"./76/Spectate/SecondaryMenu.layout": [
		5089,
		3215,
		7517
	],
	"./8/Poker/SecondaryMenu.layout": [
		23323,
		3215,
		2566
	],
	"./8/Spectate/SecondaryMenu.layout": [
		65881,
		3215,
		8792,
		1198
	],
	"./81/Kambi/SecondaryMenu.layout": [
		68634,
		3215,
		5866
	],
	"./81/Spectate/SecondaryMenu.layout": [
		85447,
		3215,
		6951
	],
	"./84/Kambi/SecondaryMenu.layout": [
		45614,
		3215,
		249
	],
	"./84/Spectate/SecondaryMenu.layout": [
		16140,
		3215,
		4040
	],
	"./86/Spectate/SecondaryMenu.layout": [
		41529,
		3215,
		1066
	],
	"./87/Spectate/SecondaryMenu.layout": [
		88894,
		3215,
		6229
	],
	"./88/Spectate/SecondaryMenu.layout": [
		93507,
		3215,
		5412
	],
	"./89/Spectate/SecondaryMenu.layout": [
		84560,
		3215,
		1066,
		9423
	],
	"./90/Spectate/SecondaryMenu.layout": [
		27186,
		3215,
		1066,
		5817
	],
	"./91/Spectate/SecondaryMenu.layout": [
		71917,
		3215,
		1066,
		398
	],
	"./92/Spectate/SecondaryMenu.layout": [
		29860,
		3215,
		2916
	],
	"./94/Spectate/SecondaryMenu.layout": [
		58521,
		3215,
		9301
	],
	"./95/Spectate/SecondaryMenu.layout": [
		71636,
		3215,
		9578
	],
	"./96/Poker/SecondaryMenu.layout": [
		91694,
		3215,
		9800
	],
	"./96/Spectate/SecondaryMenu.layout": [
		45780,
		3215,
		8792,
		8979
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 80506;
module.exports = webpackAsyncContext;